import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import api from "@/lib/api";
import { Path, Clock, CurrencyEur, Airplane, ArrowRight } from "@phosphor-icons/react";

// Reusable fare stats + booking CTA for a fixed dropoff (city id).
export default function TransferCta({ cityId, dropoffName, testid = "transfer-cta" }) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [fare, setFare] = useState(null);

  useEffect(() => {
    api.post("/fare", { pickup_id: "zrh-airport", dropoff_id: cityId, vehicle_class: "standard", time: "10:00" })
      .then((r) => setFare(r.data)).catch(() => setFare(null));
  }, [cityId]);

  const today = new Date().toISOString().slice(0, 10);
  const book = () => navigate("/book", { state: { service_type: "transfer", pickup_id: "zrh-airport", pickup_name: "Flughafen Zürich (ZRH)", dropoff_id: cityId, dropoff_name: dropoffName, date: today, time: "10:00" } });

  return (
    <div data-testid={testid}>
      <div className="grid grid-cols-3 gap-4">
        {[
          { icon: Path, label: t("dest_distance"), val: fare ? `${fare.distance_km} km` : "…" },
          { icon: Clock, label: t("dest_travel_time"), val: fare ? `~${fare.eta_minutes} min` : "…" },
          { icon: CurrencyEur, label: t("dest_price_from"), val: fare ? `CHF ${fare.total.toFixed(0)}` : "…" },
        ].map((s, i) => (
          <div key={i} className="rounded-2xl border border-[#E9E5DE] bg-white p-5" data-testid={`${testid}-stat-${i}`}>
            <s.icon size={20} className="text-[#EF5A1E]" />
            <p className="font-heading font-bold text-2xl tracking-tight text-[#0B1533] mt-3">{s.val}</p>
            <p className="font-body text-[10px] text-[#5A607A] uppercase tracking-wider mt-1">{s.label}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 rounded-3xl bg-[#0B1533] p-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
        <div className="flex items-center gap-3">
          <Airplane size={28} weight="fill" className="text-[#EF5A1E]" />
          <div>
            <p className="font-body text-xs text-white/50 uppercase tracking-wider">{t("dest_price_from")}</p>
            <p className="font-heading font-bold text-2xl text-white">{fare ? `CHF ${fare.total.toFixed(2)}` : "…"}</p>
          </div>
        </div>
        <button onClick={book} data-testid={`${testid}-book-btn`} className="inline-flex items-center gap-2 bg-[#EF5A1E] text-white font-body font-semibold rounded-full px-8 py-4 hover:bg-[#D2450F] transition-colors duration-200">
          {t("dest_book_now")} <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
